var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8787 5.70711C14.2692 5.31658 14.9024 5.31658 15.2929 5.70711C15.6834 6.09763 15.6834 6.7308 15.2929 7.12132L10.7071 11.7071L15.2929 16.2929C15.6834 16.6834 15.6834 17.3166 15.2929 17.7071C14.9024 18.0976 14.2692 18.0976 13.8787 17.7071L7.87868 11.7071L13.8787 5.70711Z",
    fill: "#17151C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.4f67d6beea28ed4c749b7216f328f221.svg";
export { ForwardRef as ReactComponent };